import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import appReducer from "./slices/appSlice/AppSlice";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import popupReducer from "./slices/popupSlice/popupSlice";
import userReducer from "./slices/userSlice/UserSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [],
};

const appStorePersistConfig = {
  key: "app",
  version: 3,
  storage,
  whitelist: [
    "personalId",
    "encryptedPersonalId",
    "travelPolicyNumber",
    "businessUnit",
    "fXEligibilityData", // this for choose policy
    "mockDataEnabled",
    "currentState", // it fix ActivateCreditCard component when the page reload
    "sessionId",
    "locationRedirectEnabled",
  ],
  blacklist: ["fXEligibilityResStatus"],
};
const userStorePersistConfig = {
  key: "user",
  version: 1,
  storage,
  whitelist: [""], // DONT Add creditCards here, it will cause the app use previous creditCards state when the page reload
};

const reducer = combineReducers({
  app: persistReducer(appStorePersistConfig, appReducer),
  popup: popupReducer,
  user: persistReducer(userStorePersistConfig, userReducer),
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
